var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconVideo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4389 18.8278C22.103 19.2778 23 18.8022 23 18V6C23 5.19783 22.103 4.72216 21.4389 5.17222L18 7.00306C18 5.34315 16.6569 4 15 4H4C2.34315 4 1 5.34315 1 7V17C1 18.6569 2.34315 20 4 20H15C16.6569 20 18 18.6569 18 17L21.4389 18.8278ZM21 7.38583V16.6142L17.5611 14.2833C16.897 13.8333 16 14.3089 16 15.1111V17C16 17.5523 15.5523 18 15 18H4C3.44772 18 3 17.5523 3 17V7C3 6.44772 3.44772 6 4 6H15C15.5523 6 16 6.44772 16 7V8.88889C16 9.69105 16.897 10.1667 17.5611 9.71667L21 7.38583Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconVideo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconVideo.c953ebcb38c3164795f52af146cfd18b.svg";